import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from 'ui-components/components/checkbox';
import { noop } from 'ui-components/default-props/noop';

import style from './style.module.less';

const FilterCheckbox = ({ onChecked = noop, isChecked = false, label }) => {
  return (
    <span className={style['toggle-sidebar-button']}>
      <Checkbox checked={isChecked} label={label} onChange={onChecked} />
    </span>
  );
};

FilterCheckbox.propTypes = {
  onChecked: PropTypes.func,
  isChecked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default FilterCheckbox;
